import { Card, Col, Stack } from "react-bootstrap";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Chart } from "react-chartjs-2";
import annotationPlugin from "chartjs-plugin-annotation";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useMemo } from "react";
import LoadingIndicator from "../LoadingIndicator";
import ErrorResponse from "../ErrorResponse";
import RATooltip from "../RATooltip";
import { toAutoDecimals } from "../HelperFunctions";
ChartJS.register(ArcElement, Tooltip, Legend, annotationPlugin, ChartDataLabels);

export default function TotalSessionsCard({ data, loading, error }) {
    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
            padding: {
                top: 1,
            },
        },
        borderRadius: 5,
        plugins: {
            legend: {
                display: false,
                position: "bottom",
                labels: {
                    usePointStyle: true,
                },
            },
            tooltip: {
                enabled: false,
            },
            datalabels: {
                color: "#142533",
                font: {
                    size: 16,
                    weight: "bold",
                },
                formatter: function (value) {
                    return value.toLocaleString();
                },
            },
            annotation: {
                clip: false,
                annotations: {
                    avg: {
                        type: "line",
                        label: {
                            display: true,
                            content: `AVG ${toAutoDecimals(data?.reach?.average, 0).toLocaleString()}`,
                            position: "start",
                            color: "#142533",
                            backgroundColor: "transparent",
                            padding: 0,
                            yAdjust: 8,
                        },
                        yMin: data?.reach?.average ?? 0,
                        yMax: data?.reach?.average ?? 0,
                        borderColor: "#142533",
                        borderWidth: 3,
                    },
                },
            },
        },
        scales: {
            y: {
                ticks: {
                    display: false,
                },
                grid: {
                    display: false,
                },
                border: {
                    display: false,
                },
            },
            x: {
                grid: {
                    display: false,
                },
                ticks: {
                    display: false,
                },
            },
        },

        interaction: {
            mode: "index",
        },
    };

    const chartData = useMemo(() => {
        if (data?.reach) {
            return {
                labels: ["Time Frame"],
                datasets: [
                    {
                        type: "bar",
                        backgroundColor: ["#fcd76b"],
                        data: [Math.round(data.reach.time_frame)],
                    },
                ],
            };
        }
    }, [data]);

    return (
        <Card>
            <Card.Header className="d-flex align-items-center px-2">
                <span className="offset-1 flex-grow-1">Sessions</span>
                <div className="col-auto d-flex justify-content-end">
                    <RATooltip size={20}>
                        <Stack gap={2}>
                            <span>Weekly average of sessions.</span>
                        </Stack>
                    </RATooltip>
                </div>
            </Card.Header>
            <Card.Body className="card-health-chart d-flex flex-column pb-1">
                {loading ? (
                    <LoadingIndicator width={85} />
                ) : error ? (
                    <ErrorResponse errorCode={error} />
                ) : (
                    <>
                        <Col>
                            <Chart data={chartData} options={chartOptions} />
                        </Col>
                        <Stack direction="horizontal" gap={1} className="align-items-center fs-8">
                            <span className="text-muted text-uppercase">Per Week: </span>
                            <span className="fw-bold">{data?.total_sessions?.time_frame.toLocaleString()}</span>
                        </Stack>
                    </>
                )}
            </Card.Body>
        </Card>
    );
}
